import { MutationOptions, gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation createGroup(
    $name: String!
    $description: String!
    $visibility: String!
    $mainCategory: String!
    $subCategories: [String]
  ) {
    createGroup(
      name: $name
      description: $description
      visibility: $visibility
      mainCategory: $mainCategory
      subCategories: $subCategories
    ) {
      group {
        id
        name
        description
        visibility
      }
      inviteToken
    }
  }
`

export interface CreateGroupInput {
  name: string
  description: string
  visibility: string
  mainCategory: string
  subCategories: string[]
}

export interface CreateGroupOutput {
  createGroup: {
    group: {
      id: string
      name: string
      description: string
      visibility: string
    }
    inviteToken: string
  }
}

export const useCreateGroup = (options?: MutationOptions<CreateGroupOutput, CreateGroupInput>) => useMutation<CreateGroupOutput, CreateGroupInput>(mutation, options)
